// extracted by mini-css-extract-plugin
module.exports = {"avDpBundleCarousel":"_3t4Gtz"};